import { Component, OnInit, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import isArray from 'lodash/isArray';

export type AlertType = 'success' | 'info' | 'warning' | 'danger';

@Component({
  selector: 'portal-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent implements OnInit {
  @Input() message: string;
  @HostBinding('class')
  @Input() type: AlertType;
  @Input() showCloseIcon;
  // constructor() { }
  alertIcon;
  alertTitle;
  alertEl: HTMLElement;
  ngOnInit(): void {
    this.alertIcon = this.switchIcons(this.type);
    this.alertTitle = this.switchTitle(this.type);
    this.alertEl = <HTMLElement>document.getElementsByTagName('portal-alert')[0];
    if (this.showCloseIcon) {
      this.alertEl.setAttribute('role', 'alertdialog');
    } else {
      this.alertEl.setAttribute('role', 'alert');
    }
  }

  switchIcons(className) {
    switch (className) {
      case 'success':
        return 'fa-check-circle'

      case 'info':
        return 'fa-info-circle'

      case 'warning':
        return 'fa-exclamation-triangle'

      case 'danger':
        return 'fa-exclamation-circle'
    }
  }

  switchTitle(type) {
    switch (type) {
      case 'danger':
        return 'Error'

      default:
        return type
    }
  }

  closeAlert() {
    this.alertEl.style.display = 'none'
  }

  isArray(obj) {
    return isArray(obj)
  }

}
